import { connect, no_render } from 'core'
import * as selectors from 'selectors';
import { GroupInfo } from 'comp/right/group_info';
import { cache } from 'utils';


const mapToProps = state => {
  const selected = selectors.getSelectedGroup();
  if(!selected) {
    return no_render
  }
  return {
    jumping:state.ui.jump_to_conv,
    selected,
    members: selectors.getSelectedGroupMembers(),
    user_id: state.user.id,
    is_admin: selected.is_admin,
    avatar_status: state.fetch.group_upload_avatar || cache.empty_obj,
    upload_avatar: state.uploader.group_avatar
  };
};

export default connect(GroupInfo,mapToProps);



// WEBPACK FOOTER //
// ./src/containers/right/GroupInfo.js